import React, {useState, useEffect} from 'react'
import {useSelector} from "react-redux";
import {getIbmAnalysis} from "../api/client";
import {Percent} from "./Percent";
import {Section} from "./Section";
import {CenteredSpinner} from "./CenteredSpinner";

export const IbmTab = () => {
    
    const [analysis, setAnalysis] = useState();
    const selectedMeetingId = useSelector(state => state.users.selectedMeetingId);

    const loadIbmAnalysis = async () => {
        setAnalysis(null);
        let analysis = await getIbmAnalysis(selectedMeetingId);
        setAnalysis(analysis);
    }
    
    useEffect(() => {
        if(selectedMeetingId != null) {
            loadIbmAnalysis();
        }
    }, [selectedMeetingId]);

    if(selectedMeetingId == null)
        return <div>No meeting selected.</div>

    if(analysis == null)
        return <CenteredSpinner height="70vh" message="Loading..."/>
    
    return <div>
        <div style={{display: "flex", gap: "24px"}}>
            <div>
                <div className="header">Sentiment</div>
                <div className="meetingPanel">
                    <Section headers={['sentiment', 'score']}>
                        <tr>
                            <td>{analysis.sentiment.document.label}</td>
                            <td><Percent percent={analysis.sentiment.document.score} /></td>
                        </tr>
                    </Section>
                </div>
                <div className="header">Emotion</div>
                <div className="meetingPanel">
                    <Section headers={['emotion', 'score']}>
                        <tr>
                            <td>sadness</td>
                            <td><Percent percent={analysis.emotion.document.emotion.sadness} /></td>
                        </tr>
                        <tr>
                            <td>joy</td>
                            <td><Percent percent={analysis.emotion.document.emotion.joy} /></td>
                        </tr>
                        <tr>
                            <td>fear</td>
                            <td><Percent percent={analysis.emotion.document.emotion.fear} /></td>
                        </tr>
                        <tr>
                            <td>disgust</td>
                            <td><Percent percent={analysis.emotion.document.emotion.disgust} /></td>
                        </tr>
                        <tr>
                            <td>anger</td>
                            <td><Percent percent={analysis.emotion.document.emotion.anger} /></td>
                        </tr>
                    </Section>
                </div>
                <div className="header">Concepts</div>
                <div className="meetingPanel">
                    <Section headers={['concept']}>
                        {analysis.concepts.map(x=><tr><td>{x.text}</td></tr>)}
                    </Section>
                </div>
                <div className="header">Categories</div>
                <div className="meetingPanel">
                    <Section headers={['category', 'score']}>
                        {analysis.categories.map(x=><tr><td>{x.label}</td><td><Percent percent={x.score} /></td></tr>)}
                    </Section>
                </div>
                </div>
            <div>
                <div className="header">Entities</div>
                <div className="meetingPanel" style={{height: "75vh", overflow: "auto"}}>
                    <Section headers={['type', 'entity', 'relevance', 'count', 'confidence']}>
                        {analysis.entities.map(x=><tr><td>{x.type}</td><td>{x.text}</td><td><Percent percent={x.relevance}/></td><td>{x.count}</td><td><Percent percent={x.confidence}/></td></tr>)}
                    </Section>
                </div>

            </div>
            <div>
            <div className="header">Keywords</div>
                <div className="meetingPanel" style={{height: "75vh", overflow: "auto"}}>
            <Section headers={['keyword', 'relevance', 'count']}>
                {analysis.keywords.map(x=><tr><td>{x.text}</td><td><Percent percent={x.relevance} /></td><td>{x.count}</td></tr>)}
            </Section>
                </div>
            </div>
        </div>
    </div>

};